import { create } from 'zustand';
import { GUESTS_TYPE } from '../../constants';

export const createRoomsSlice = (set, get) => ({
  rooms: [],
  setRooms: (rooms) => set({ rooms }),
  roomAdd: (room) => set({
    rooms: [
      ...get().rooms,
      {
        key: room?.key || Math.random().toString(36).slice(2),
        data: room?.data || [{ type: GUESTS_TYPE.ADULT, count: get().hotelData?.default_adult_occupancy || 1 }],
      },
    ],
  }),
  roomRemove: (key) => set({
    rooms: get().rooms?.filter((room) => room.key !== key),
  }),
  roomUpdate: (key, payload) => set({
    rooms: get().rooms?.map((room) => {
      return room.key === key ? { ...room, ...payload } : room;
    }),
  }),
});
